import {
  ingenuity,
  dispatcher,
  IEvent,
  Loading,
  BaseCoreConstants,
  EventConstants,
  delayedCall,
  killDelayedCall,
  clone,
  IObject,
} from "@quest/base-core";
import { GameLogic, SlotEventConstantsBehavior, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { EventConstants as PlatformEventConstants } from "@quest/platform-core";
import { SlotEventConstants, SlotConstants } from "@quest/slot-core";
import { EventConstantsLeander } from "@quest/oddsworks-platform";

import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class GameClientLogic extends GameLogic {
  private spinSoundPause: boolean = false;
  /**
   * to subscribe feature specific events
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.START_STICKY_WILD_FG, this.startStickyWildFg, this);
    dispatcher.on(eventDispatchers.START_FG_FIRST_SPIN, this.startFgFirstSpin, this);
    dispatcher.on(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION, this.showNextFeaturePresentation, this);
    dispatcher.on(eventDispatchers.WILD_LANDED_ON_REEL, this.onWildDragonLanded, this);
    dispatcher.on(eventDispatchers.HANDLE_FEATURE_ON_BET_CHANGE, this.handelFlowerCollectOnBetChange, this);
    dispatcher.on(eventDispatchers.UPDATE_GRID_ON_LAST_WILD, this.updateReelGridOnWildEnd, this);
    dispatcher.on(eventDispatchers.HANDLE_FEATURE_ON_REFRESH, this.handelFlowerCollectRefresh, this);
    dispatcher.on(eventDispatchers.HANDLE_FEATURE_ON_BROKEN, this.handelFlowerCollectBroken, this);
    dispatcher.on(eventDispatchers.ADD_DISABLED_ONION_ON_REEL, this.addDisableOnionOnReel, this);
  }
  /**
   * to UNsubscribe feature specific events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.WILD_LANDED_ON_REEL, this.onWildDragonLanded, this);
    dispatcher.off(eventDispatchers.START_STICKY_WILD_FG, this.startStickyWildFg, this);
    dispatcher.off(eventDispatchers.START_FG_FIRST_SPIN, this.startFgFirstSpin, this);
    dispatcher.off(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION, this.showNextFeaturePresentation, this);
    dispatcher.off(eventDispatchers.HANDLE_FEATURE_ON_BET_CHANGE, this.handelFlowerCollectOnBetChange, this);
    dispatcher.off(eventDispatchers.UPDATE_GRID_ON_LAST_WILD, this.updateReelGridOnWildEnd, this);
    dispatcher.off(eventDispatchers.HANDLE_FEATURE_ON_REFRESH, this.handelFlowerCollectRefresh, this);
    dispatcher.off(eventDispatchers.HANDLE_FEATURE_ON_BROKEN, this.handelFlowerCollectBroken, this);
    dispatcher.off(eventDispatchers.ADD_DISABLED_ONION_ON_REEL, this.addDisableOnionOnReel, this);
  }
  //Method overrided to reset freegame broken data after returning from freegame
  protected onCloseResponseReceived(evt: IEvent): void {
    super.onCloseResponseReceived(evt);
    if (ingenuity.configData.isReturningFromFreegame) {
      dispatcher.fireEvent(
        EventConstantsLeander.SAVE_DATA_REQUEST,
        (ingenuity.parserModel as GameParserModel).getUserGameCloseData()
      );
      ingenuity.configData.isReturningFromFreegame = false;
    }
  }

  /**
   * to start first spin of freegame after selection screen
   */
  private startFgFirstSpin(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.START_FG_SPIN);
  }
  /**
   * to show sticky Wilds on fg reel
   */
  private startStickyWildFg(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsStickyWildAvailable()) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_REELS_FG_VIEW);
      dispatcher.fireEvent(eventDispatchers.SHOW_STICKY_WILD_ON_REEL_FG);
    }
  }
  /**
   * tp add game specific sequence
   */
  protected onShowNextWinPresentation(evt?: IEvent): void {
    const winSequenceCounter = this.model.getAnimationSequenceCounter(); // animation sequence counter , which increase its value agter every win sequence execution
    if (winSequenceCounter >= this.model.getAnimationSequence().length) {
      return;
    }
    const sequenceArray: string[] = this.model.getAnimationSequence(); // animation sequence array
    const currentWinEventToShow = sequenceArray[winSequenceCounter]; // current win presentation to show from win sequence
    switch (currentWinEventToShow) {
      case "stackSymbolFg":
        this.updateAnimationSequenceCounter();
        this.onShowStackSymbolFg();
        break;
      case "selectFreeGame":
        this.updateAnimationSequenceCounter();
        this.showFreeGameSelectionScreen();
        break;
      case "sendCloseRequest":
        this.updateAnimationSequenceCounter();
        this.sendCloseRequest();
        break;
      default:
        super.onShowNextWinPresentation(evt);
        break;
    }
  }
  /**
   * to manage triggering animation
   */
  protected onTriggeringAnimation(): void {
    if (
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState &&
      this.model.getIsScatterWins()
    ) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.FS_WIN, 1, false, gameConstants.SOUND_LIST_PRELOAD);
      super.onTriggeringAnimation();
      dispatcher.fireEvent(eventDispatchers.SUPSPEPND_WILD_DRAGON_WIN);
    } else {
      this.showNextWinPresentation();
    }
  }
  /**
   * Method onShowStackSymbol overrided to update functionality
   *  - to add stack symbol
   */
  private onShowStackSymbolFg(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getHasLineWins() &&
      (ingenuity.parserModel as GameParserModel).getStackSymPresentFG() &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState
    ) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_FREEGAME_STACK_FEATURE);
      dispatcher.fireEvent(eventDispatchers.SHOW_LARGE_STACK_SYMBOL_FG);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  // Add to show free game selection screen
  private showFreeGameSelectionScreen(): void {
    if ((ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()) {
      this.stopAutoplayBeforeFeature();
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_FREE_GAME)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_SELECTION_SCREEN);
        dispatcher.fireEvent(eventDispatchers.SHOW_SELECTION_SCREEN);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.on(
          EventConstants.FREEGAME_ASSETS_LOADED,
          (e: IEvent) => {
            this.showFreeGameSelectionScreen();
          },
          this,
          true
        );
      }
    } else {
      this.onShowNextWinPresentation();
    }
  }
  /**
   * overrided to destroy selection sscreen while entering freegame
   */
  protected onFreeSpinPresentation(): void {
    super.onFreeSpinPresentation();
    if (
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState &&
      (ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining() > 0
    ) {
      this.updateBGWildGridInFG();
      if ((ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()) {
        dispatcher.fireEvent(eventDispatchers.DESTROY_SELECTION_SCREEN);
      }
    }
  }
  /**
   * FUNCTION TO update reel grid for wilds inside freeegame
   */
  private updateBGWildGridInFG(): void {
    const WildGrid: boolean[] = clone(ingenuity.configData.checkForActualWild);
    let basegameWildReel: number[][] = clone((ingenuity.parserModel as GameParserModel).getReelGrid());
    ingenuity.configData.checkForLastFlower.forEach((element: number) => {
      WildGrid[element] = true;
    });
    WildGrid.forEach((element: boolean, index: number) => {
      if (element) {
        basegameWildReel[index][0] = gameConstants.WILD_STACK_SYM_NUM;
        basegameWildReel[index][1] = gameConstants.TRANSPARENT_SYM_NUM;
        basegameWildReel[index][2] = gameConstants.TRANSPARENT_SYM_NUM;
        basegameWildReel[index][3] = gameConstants.TRANSPARENT_SYM_NUM;
      }
    });
    (ingenuity.parserModel as GameParserModel).setReelGrid(basegameWildReel);
  }
  /**
   * to show static symbol on screen
   */
  protected resetPresentationsOnSpinClickFg(): void {
    killDelayedCall("SHOW_SPAGHTTI");
    killDelayedCall(SlotConstants.TimerForNextFreeSpin);
    dispatcher.fireEvent(SlotEventConstants.FG_SUSPEND_WINPRESENTATION);
    dispatcher.fireEvent(SlotEventConstants.CLEAR_SPIN_TIMER);
    dispatcher.fireEvent(SlotEventConstants.REMOVE_ALL_LISTNERS_FROM_STAGE);
    dispatcher.fireEvent(SlotEventConstants.FG_DISABLED_ALL_BUTTONS);
    dispatcher.fireEvent(SlotEventConstants.FG_CLEAR_DATA);
    if (this.model.getFreeSpinsRemaining() === 0) {
      dispatcher.fireEvent(SlotEventConstants.DO_NEXT_SPIN);
    } else {
      dispatcher.fireEvent(SlotEventConstants.VALIDATE_BET_IN_FREEGAME);
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREESPIN_LABEL_COUNT);
    if (this.model.getIsBigWinRunning() && !ingenuity.configData.isForceStopDuringPot) {
      (ingenuity.parserModel as GameParserModel).setIsSpinClicked(true);
    }
    ingenuity.configData.isPlayAnticipationSound = false;
    ingenuity.configData.spinStopPressed = false;
    dispatcher.fireEvent(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK_FG);
  }
  /**
   * Method resetPresentationsOnSpinClick overrided to update functionality
   */
  protected resetPresentationsOnSpinClick(): void {
    if (this.model.getIsBigWinRunning()) {
      (ingenuity.parserModel as GameParserModel).setIsSpinClicked(true);
      dispatcher.fireEvent(SlotEventConstants.SUMUP_BIGWIN);
      /**to show winamount in winmeter for some time on spin click
       * reset it after some delay
       */
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_WIN_VALUE_TO_DEFAULT);
    dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    killDelayedCall("SHOW_SPAGHTTI");
    killDelayedCall("5OKind");
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
    if ((ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining() > 0) {
      killDelayedCall(SlotConstantsBehavior.ClearBigWinCompleteDelayer);
      delayedCall(
        SlotConstantsBehavior.ClearBigWinCompleteDelayer,
        SlotConstantsBehavior.ClearBigWinCompleteTimer / 2,
        () => {
          this.onFreeSpinPresentation();
        }
      );
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAYER_MSG_SPIN_CLICK);
      if (!this.model.getIsBigWinRunning()) {
        this.processingSpinClicked();
        this.model.setIsBigWinRunning(false);
      }
    }
    ingenuity.configData.checkForLastFlower = [];
    dispatcher.fireEvent(eventDispatchers.PLAY_EAT_FLOWER_ANIM);
    dispatcher.fireEvent(eventDispatchers.HIDE_LARGE_STACK_SYMBOL);
    dispatcher.fireEvent(eventDispatchers.SHOW_STATIC_SYMBOL_BEHIND_STACK);
    ingenuity.configData.spinStopPressed = false;
    dispatcher.fireEvent(eventDispatchers.RESET_FLOWER_PANEL_ANIMATION);
    dispatcher.fireEvent(eventDispatchers.RESET_GLOW_EFFECT_ANIMATION);
    ingenuity.configData.isPlayAnticipationSound = false;
  }
  /**
   * TO PLAY STACK SYM ANIMATION
   */
  protected onShowAllFrames(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresent() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0
    ) {
      dispatcher.fireEvent(eventDispatchers.PLAY_STACK_WIN_ANIMATION);
    }
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresentFG() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0
    ) {
      dispatcher.fireEvent(eventDispatchers.PLAY_STACK_WIN_ANIMATION_FG);
    }
    if ((ingenuity.parserModel as GameParserModel).getHasLineWins()) {
      super.onShowAllFrames();
    } else {
      this.onShowNextWinPresentation();
    }
  }
  /**
   * Method onSpinClicked overided to update functionality
   */
  protected onSpinClickedInFreeGame(evt: IEvent): void {
    super.onSpinClickedInFreeGame(evt);
    ingenuity.configData.spinComplete = false;
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin([]);
  }
  /**
   * Method onSpinClicked overided to update functionality
   */
  protected onSpinClicked(evt: IEvent): void {
    super.onSpinClicked(evt);
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin([]);
  }
  protected onShowBigWin() {
    super.onShowBigWin();
    if (this.model.getIsBigWin() && ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      this.updateDisableOnionOnBigWin();
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    }
  }
  /**
   * to manage symbol togglening
   */
  protected onFirstToggle(): void {
    ingenuity.configData.playAllSymbolAnim = false;
    if (this.model.getIsAutoPlayLeft()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    } else {
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        if (
          (ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable() &&
          this.model.getIsLineWins() &&
          this.model.getWinLinesData().length > 0
        ) {
          dispatcher.fireEvent(SlotEventConstantsBehavior.BEGIN_STAGE_CLICK);
          ingenuity.configData.enableStageClickOnFirstToggle = true;
          dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_STAGE_CLICK_PLAYER_MSG);
        }
      }
      if (this.model.getIsLineWins()) {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
          dispatcher.fireEvent(SlotEventConstants.FG_START_FIRST_TOGGLE_CYCLE);
        } else {
          dispatcher.fireEvent(SlotEventConstants.START_FIRST_TOGGLE_CYCLE);
        }
      } else {
        this.showNextWinPresentation();
      }
    }
  }
  /**
   * Overrided to handle fg without line win case
   */
  protected onCheckForWinAfterReelStop(evt?: IEvent): void {
    if (
      (ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() ||
      (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()
    ) {
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SHOW_SPIN_BTN_HIDE_STOP_BTN);
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_SPIN_BTN_HIDE_STOP_BTN);
    }
    // Condition add to handle free game trigger with base game no win
    if (
      (this.model.getIsWin() &&
        (ingenuity.parserModel.getTotalWin() || (ingenuity.parserModel as GameParserModel).getFreeSpinTotalWin())) ||
      (ingenuity.parserModel as GameParserModel).getIsFreeSpinRetriggered()
    ) {
      this.setWinlineAndWaysData();
      killDelayedCall(SlotConstantsBehavior.BROKEN_DELAY_FG);
      this.showNextWinPresentation();
    } else if ((ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()) {
      this.onShowNextWinPresentation();
    } else {
      killDelayedCall(SlotConstantsBehavior.NoWinDelay);
      delayedCall(SlotConstantsBehavior.NoWinDelay, SlotConstantsBehavior.setDelayForNoWin, () => {
        dispatcher.fireEvent(SlotEventConstants.SHOW_CONTAINERS, SlotConstantsBehavior.ButtonsContainerId);
      });
    }
    (ingenuity.parserModel as GameParserModel).setisSpinStarted(false);
  }

  // Override to handle close game request when free game trigger
  protected sendCloseRequest(): void {
    if (
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState &&
      !ingenuity.configData.endReqSent
    ) {
      if (
        !(ingenuity.parserModel as GameParserModel).getHasFreeGamesWin() &&
        !(ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()
      ) {
        // condition added
        if ((ingenuity.parserModel as GameParserModel).getNoSettleOnError()) {
          (ingenuity.parserModel as GameParserModel).setNoSettleOnError(false);
          dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
        } else {
          dispatcher.fireEvent(PlatformEventConstants.GAME_CLOSE);
        }
        ingenuity.configData.endReqSent = true;
      }
    } else if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.DO_NEXT_SPIN);
    }
  }
  /**
   * overrided to reset feature sequence counter
   */
  protected onValidateBet(evt: IEvent): void {
    super.onValidateBet(evt);
    this.model.resetFeatureSequenceCounter();
  }

  /**
   * function will handle the feature sequence in case of win or no win both
   */
  private showNextFeaturePresentation(): void {
    const featureSequenceCount = this.model.getFeatureSequenceCounter();
    if (featureSequenceCount >= this.model.getFeatureSequence().length) {
      return;
    }
    const sequenceArray: string[] = this.model.getFeatureSequence(); // animation sequence array
    const currSequence = sequenceArray[featureSequenceCount]; // current win presentation to show from win sequence
    this.model.updateFeatureSequenceCounter();
    switch (currSequence) {
      case "stackSymbolBg":
        this.onShowStackSymbolBg();
        break;
      case "showFlowerTrail":
        this.onShowFlowerTrail();
        break;
      case "showCollectedFlower":
        this.onShowCollectedFlower();
        break;
      case "showWildDragonsOnReel":
        this.showWildReelDragonOnReelBG();
        break;
      case "showPurpleToGoldenWild":
        this.onShowPurpleToGoldenWild();
        break;
      case "checkForNoWin":
        this.onCheckForNoWin();
        break;
      case "checkForWinAfterReelStop":
        this.onCheckForWinAfterReelStop();
        break;
    }
  }
  /**
   * to show transition and static frame for stack symbols
   */
  private onShowStackSymbolBg(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getHasLineWins() &&
      (ingenuity.parserModel as GameParserModel).getStackSymPresent() &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_BASEGAME_STACK_FEATURE);
      dispatcher.fireEvent(eventDispatchers.SHOW_LARGE_STACK_SYMBOL);
    } else {
      this.showNextFeaturePresentation();
    }
  }
  /**
   * to show flower trail on spin complete
   */
  private onShowFlowerTrail(): void {
    if ((ingenuity.parserModel as GameParserModel).getOnionOffset().length) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_FLOWER_ONION_TRAIL);
      dispatcher.fireEvent(eventDispatchers.SHOW_FLOWER_TRAIL);
    } else {
      this.showNextFeaturePresentation();
    }
  }
  /**
   * to show flowers on collect panel
   */
  private onShowCollectedFlower(): void {
    this.updateDisableOnionOnBigWin();
    if ((ingenuity.parserModel as GameParserModel).getOnionOffset().length) {
      dispatcher.fireEvent(eventDispatchers.SHOW_COLLECTED_FLOWERS_ON_PANEL);
    }
    this.showNextFeaturePresentation();
  }
  /**
   * to show wild dragons on reel
   */
  private showWildReelDragonOnReelBG(): void {
    if ((ingenuity.parserModel as GameParserModel).getWildOnReel().length) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(eventDispatchers.SHOW_MINI_SKULL_ANIMS);
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_DRAGON);
        dispatcher.fireEvent(eventDispatchers.START_WILD_DRAGON_FEATURE);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED, (e: IEvent) => {
          this.showWildReelDragonOnReelBG();
        });
      }
    } else {
      this.showNextFeaturePresentation();
    }
  }
  /**
   * to show gold frame during last spin
   */
  private onShowPurpleToGoldenWild(): void {
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    if (purpleWild.length > 0) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_FREE_GAME)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(eventDispatchers.SHOW_PURPLE_FLOWER_CONTAINER_TO_GOLDEN);
        dispatcher.fireEvent(eventDispatchers.PURPLE_TO_GOLD_WILD_ANIM);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(EventConstants.FREEGAME_ASSETS_LOADED, (e: IEvent) => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
          dispatcher.fireEvent(eventDispatchers.SHOW_PURPLE_FLOWER_CONTAINER_TO_GOLDEN);
          dispatcher.fireEvent(eventDispatchers.PURPLE_TO_GOLD_WILD_ANIM);
        });
      }
    } else {
      this.showNextFeaturePresentation();
    }
  }
  /**
   * to check win and no win scenarios to handle close request after feature
   */
  private onCheckForNoWin(): void {
    if (!this.model.getIsWin()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
    }
    this.showNextFeaturePresentation();
  }

  /**
   * fired when the wild is landed on reel in collect feature
   */
  private onWildDragonLanded(evt: IEvent): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_REEL_BEHIND_WILD_BG, evt.data);
    dispatcher.fireEvent(eventDispatchers.SHOW_PURPLE_FRAME, evt.data);
  }
  /**
   * to handle flowers and wilds on bet change
   */
  private handelFlowerCollectOnBetChange(): void {
    ingenuity.configData.checkForLastFlower = [];
    dispatcher.fireEvent(eventDispatchers.HIDE_LARGE_STACK_SYMBOL);
    dispatcher.fireEvent(eventDispatchers.HANDLE_FLOWERS_ON_BET_CHANGE);
    dispatcher.fireEvent(eventDispatchers.RESET_FLOWER_PANEL);
    dispatcher.fireEvent(eventDispatchers.ENABLE_ANIM_REEL_ON_BET_CHANGE);
    dispatcher.fireEvent(eventDispatchers.RESET_WILD_ON_REEL);
    this.handelFlowerCollectRefresh();
    this.updateReelGridOnWildEndOnBetChange();
    dispatcher.fireEvent(
      eventDispatchers.ADD_DISABLED_ONION_ON_REEL,
      (ingenuity.parserModel as GameParserModel).getCurrentBetGrid()
    );
  }
  /**
   * to handle flower collect data while refresh
   */
  private handelFlowerCollectRefresh(): void {
    dispatcher.fireEvent(eventDispatchers.RESET_FLOWER_PANEL);
    dispatcher.fireEvent(eventDispatchers.COLLECTED_FLOWERS_ON_BET_CHANGE);
    if (
      (ingenuity.parserModel as GameParserModel).getWildOnReel().length ||
      (ingenuity.parserModel as GameParserModel).getPreWildOnReel().length
    ) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_DRAGON);
        dispatcher.fireEvent(eventDispatchers.COLLECTED_WILD_ON_BET_CHANGE);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED, (e: IEvent) => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
          dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
          dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_DRAGON);
          dispatcher.fireEvent(eventDispatchers.COLLECTED_WILD_ON_BET_CHANGE);
        });
      }
    }
  }
  /**
   * to show flowers and wild during broken
   */
  private handelFlowerCollectBroken(): void {
    dispatcher.fireEvent(eventDispatchers.COLLECTED_FLOWERS_ON_BROKEN);
    if ((ingenuity.parserModel as GameParserModel).getPreWildOnReel().length) {
      if (Loading.isStateLoaded(BaseCoreConstants.loader.STAGE_BASE_GAME_POSTLOAD)) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_DRAGON);
        dispatcher.fireEvent(eventDispatchers.COLLECTED_WILD_ON_BROKEN);
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_POST_LOADER);
        dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
        dispatcher.on(EventConstants.BASEGAME_POSTLOAD_ASSETS_LOADED, (e: IEvent) => {
          dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
          dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_DRAGON);
          dispatcher.fireEvent(eventDispatchers.COLLECTED_WILD_ON_BROKEN);
        });
      }
    }
  }
  /**
   * FUNCTION TO update reel grid on last wild
   */
  private updateReelGridOnWildEnd(): void {
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    if (purpleWild.length > 0) {
      dispatcher.fireEvent(eventDispatchers.STORE_GRID_WITH_BET);
      let basegameWildReel: number[][] = clone(
        (ingenuity.parserModel as GameParserModel).getCurrentBetGrid()
          ? (ingenuity.parserModel as GameParserModel).getCurrentBetGrid()
          : (ingenuity.parserModel as GameParserModel).getReelGrid()
      );
      purpleWild.forEach((element: number) => {
        basegameWildReel[element][0] = gameConstants.WILD_STACK_SYM_NUM;
        basegameWildReel[element][1] = gameConstants.TRANSPARENT_SYM_NUM;
        basegameWildReel[element][2] = gameConstants.TRANSPARENT_SYM_NUM;
        basegameWildReel[element][3] = gameConstants.TRANSPARENT_SYM_NUM;
        dispatcher.fireEvent(eventDispatchers.REMOVE_WILD_FROM_REEL, element);
      });
      dispatcher.fireEvent(eventDispatchers.ADD_DISABLED_ONION_ON_REEL, basegameWildReel);
      dispatcher.fireEvent(eventDispatchers.SHOW_ANIM_REEL);
    }
  }

  private updateReelGridOnWildEndOnBetChange(): void {
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    if (purpleWild.length > 0) {
      dispatcher.fireEvent(eventDispatchers.STORE_GRID_WITH_BET);
      let basegameWildReel: number[][] = clone(
        (ingenuity.parserModel as GameParserModel).getCurrentBetGrid()
          ? (ingenuity.parserModel as GameParserModel).getCurrentBetGrid()
          : (ingenuity.parserModel as GameParserModel).getReelGrid()
      );
      purpleWild.forEach((element: number) => {
        basegameWildReel[element][0] = gameConstants.WILD_STACK_SYM_NUM;
        basegameWildReel[element][1] = gameConstants.TRANSPARENT_SYM_NUM;
        basegameWildReel[element][2] = gameConstants.TRANSPARENT_SYM_NUM;
        basegameWildReel[element][3] = gameConstants.TRANSPARENT_SYM_NUM;
      });
      dispatcher.fireEvent(eventDispatchers.ADD_DISABLED_ONION_ON_REEL, basegameWildReel);
      dispatcher.fireEvent(eventDispatchers.SHOW_ANIM_REEL);
    }
  }
  /**overrided to stop multiple onMarkerComplete Bindings. */
  protected onVisibilityChange(evt: IObject) {
    super.onVisibilityChange(evt);
    if (evt.target.visibilityState === "visible") {
      this.resumeSpinMusic();
    } else {
      if (
        ingenuity.deviceEnv.browser !== "EDGE" &&
        ingenuity.deviceEnv.browser !== "IE10" &&
        ingenuity.deviceEnv.browser !== "IE11"
      ) {
        const soundInstance = (ingenuity.soundManager as any).getSoundInstance(
          SoundConstantGame.MUSIC_SPIN,
          "soundList"
        );
        if (soundInstance && soundInstance.soundPlaying) {
          (ingenuity.soundManager as any).pause(SoundConstantGame.MUSIC_SPIN);
          this.spinSoundPause = true;
        }
        if (
          !ingenuity.deviceEnv.isDesktop &&
          (ingenuity.deviceEnv.getIsIpad() || ingenuity.deviceEnv.getDeviceOS() !== "ios")
        ) {
          dispatcher.fireEvent(eventDispatchers.DISABLE_FULL_SCREEN_GAME);
        }
      }
    }
  }

  /**spin music sound presentation */
  private resumeSpinMusic(): void {
    if (
      ingenuity.deviceEnv.browser !== "EDGE" &&
      ingenuity.deviceEnv.browser !== "IE10" &&
      ingenuity.deviceEnv.browser !== "IE11"
    ) {
      if (this.spinSoundPause) {
        const audioController: any = ingenuity.soundManager as any;
        audioController.resume(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
        this.spinSoundPause = false;
        audioController.getSoundInstance(SoundConstantGame.MUSIC_SPIN).onMarkerComplete.addOnce(() => {
          if ((ingenuity.parserModel as GameParserModel).getHasWin() || this.model.isReelSpinning()) {
            dispatcher.fireEvent(eventDispatchers.PLAY_MUSIC_SPIN);
          } else {
            audioController.playSound(SoundConstantGame.BASEGAME_BGMLOOP, 1, true, gameConstants.SOUND_LIST_PRELOAD);
          }
        }, this);
      }
    }
  }
  /**
   * to add disabled onion frame after onion trail
   */
  private addDisableOnionOnReel(evt: IEvent): void {
    const grid = evt.data;
    if (grid.length) {
      for (let i = 0; i < grid.length; i++) {
        for (let j = 0; j < grid[i].length; j++) {
          if (grid[i][j] === gameConstants.SPECIAL_SYM_NUM) {
            grid[i][j] = gameConstants.SPECIAL_DISABLE_SYM_NUM;
          }
        }
      }
    }
    const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
    if (purpleWild.length > 0) {
      purpleWild.forEach((element: number) => {
        grid[element][0] = gameConstants.WILD_STACK_SYM_NUM;
        grid[element][1] = gameConstants.TRANSPARENT_SYM_NUM;
        grid[element][2] = gameConstants.TRANSPARENT_SYM_NUM;
        grid[element][3] = gameConstants.TRANSPARENT_SYM_NUM;
      });
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_SYMBOLS_ON_GRID, grid);
  }
  private updateDisableOnionOnBigWin(): void {
    const grid = (ingenuity.parserModel as GameParserModel).getReelGrid();
    if (grid.length) {
      for (let i = 0; i < grid.length; i++) {
        for (let j = 0; j < grid[i].length; j++) {
          if (grid[i][j] === gameConstants.SPECIAL_SYM_NUM) {
            grid[i][j] = gameConstants.SPECIAL_DISABLE_SYM_NUM;
          }
        }
      }
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_SYMBOLS_ON_GRID, grid);
  }

  protected startAutoPlayClicked(evt: IEvent) {
    ingenuity.configData.isAutoplayActive = true;
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
    dispatcher.fireEvent(SlotEventConstants.AUTOPLAY_COUNT, evt.data);
    dispatcher.fireEvent(SlotEventConstants.RESET_METERS);
    dispatcher.fireEvent(SlotEventConstants.CHECK_FOR_AUTOPLAY_CONDITION);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_AUTOPLAY_ON_BTN);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_AUTOPLAY_OFF_BTN);
    dispatcher.fireEvent(SlotEventConstants.UPDATE_AUTOPLAY_METERS);
    dispatcher.fireEvent(SlotEventConstants.ENABLE_BUTTON, [SlotConstantsBehavior.AutoPlayOffBtnId]);
  }

  protected checkForAutoPlay(): void {
    let delayTime = 0;
    if (this.model.getIsBigWin() && !ingenuity.configData.AutoplayBtnClicked) {
      delayTime = SlotConstantsBehavior.AutoPlayDelayBigWin;
    } else if (this.model.getIsWin() && !ingenuity.configData.AutoplayBtnClicked) {
      delayTime = SlotConstantsBehavior.AutoPlayDelayWin;
    }
    ingenuity.configData.AutoplayBtnClicked = false;
    delayedCall("autoplaydelay", delayTime, () => {
      this.model.getIsAutoPlayLeft() && dispatcher.fireEvent(SlotEventConstants.SPIN_CLICKED);
      !this.model.getIsAutoPlayLeft() && dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
    });
  }

  protected onSpinResponseReceived(evt: IEvent): void {
    super.onSpinResponseReceived(evt);
    if ((ingenuity.parserModel as GameParserModel).getIsOutOfBalance()) {
      this.handleGameAfterErrorResolved();
    }
  }
  handleGameAfterErrorResolved() {
    if (ingenuity.configData.isBSPOTEnable) {
      (ingenuity.parserModel as GameParserModel).setIsSpinClicked(false);
      ingenuity.configData.spinComplete = true;
      dispatcher.fireEvent(SlotEventConstants.CHECK_FOR_WIN_AFTER_REEL_STOP);
      if (!this.model.getIsWin()) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
      }
    }
  }
}
